exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rfeed-featured__action--book.active{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" stroke=\"%231097E2\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z\"></path></svg>')}.rfeed-featured__cont{position:relative}.rfeed-featured__cont .saved-content__link{display:block;margin:16px 0 0;font-size:1rem;color:#1097e2;z-index:1000}", ""]);

// exports
